import React from "react";

const SwitchView = ({ value = false, label = "" }) => {
  return (
    <div className="my-4">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize mb-1">
        {label}
      </h1>
      <label className="inline-flex items-center">
        <label
          className={`relative w-11 h-6 bg-greyText rounded-full  ${
            value ? "bg-primary" : ""
          }`}
        >
          <label
            className={`absolute top-[2px] ${
              value ? "start-[calc(100%-22px)]" : "start-[2px]"
            } h-5 w-5 rounded-full transition-all bg-white`}
          />
        </label>
      </label>
    </div>
  );
};

export default SwitchView;
